import * as React from "react";
import { LeagueIcon } from "../..";
import { Icon } from "sb-resp-ui";

export const renderLiveStreamIcon = (hasLiveStreaming: boolean, liveStreamTooltip: string) => {
    return (
        hasLiveStreaming ?
            <LeagueIcon className="rj-league-list__live-stream-icon" tooltip={liveStreamTooltip}>
                <Icon i="i-24-16 i-o-ev-streaming" />
            </LeagueIcon>
            : <></>
    )
}